<template>
  <pt-roles-table class="pt-roles-table__withData" :tableLabels="tableLabels" :page-size="pageSize" @getTableData="getTableData"
  ref="table" :tableData="tableData" :totalNumber="totalNumber">
      <slot/>
  </pt-roles-table>
</template>

<script>
import PtRolesTable from './index'
export default {
  name: 'pt-roles-table__withData',
  components: {
    'pt-roles-table': PtRolesTable
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0
    }
  },
  methods: {
    getTableData (page, next) {
      let data = {
        page: this.page,
        size: this.pageSize
      }
      this.$store.dispatch('rolesStatistics', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.error(err || '获取角色列表失败')
      })
    }
  }
}
</script>
